import Table, { ITable, ITableContext, TTableProps } from './Table';

export type { ITableContext, ITable, TTableProps };
export default Table;
